export default __webpack_public_path__ + "static/Romie-Regular-Italic-1c55868b4d01ba30307cc4de2b8bb1a7.woff2";